import React, {
    useEffect,
    useState,
} from "react";

import {
    Stack,
    FormControl,
    FormLabel,
    Switch,
    Flex,
    Badge,
} from "@chakra-ui/react";

import ReusableDrawer from "components/Drawers/ReusableDrawer";
import GradientButton from "components/Buttons/GradientButton";
import ReusableInput from "components/Inputs/ReusableInput";

const EditCommissionRuleDrawer = ({
    isOpen,
    onClose,
    rule,
    onUpdate,
}) => {
    const [formData, setFormData] =
        useState({
            amount: "",
            active: true,
            effective_from: "",
        });

    useEffect(() => {
        if (rule) {
            setFormData({
                amount:
                    rule.amount || "",
                active:
                    rule.active ??
                    true,
                effective_from:
                    rule.effective_from
                        ? new Date(
                              rule.effective_from
                          )
                              .toISOString()
                              .slice(
                                  0,
                                  16
                              )
                        : "",
            });
        }
    }, [rule]);

    const handleChange = (
        e
    ) => {
        const {
            name,
            value,
        } = e.target;

        setFormData(
            (prev) => ({
                ...prev,
                [name]:
                    value,
            })
        );
    };

    const handleToggle = (
        e
    ) => {
        setFormData(
            (prev) => ({
                ...prev,
                active:
                    e.target
                        .checked,
            })
        );
    };

    const handleSubmit = () => {
        onUpdate({
            amount:
                Number(
                    formData.amount
                ),
            active:
                formData.active,
            effective_from:
                new Date(
                    formData.effective_from
                ).toISOString(),
        });

        onClose();
    };

    return (
        <ReusableDrawer
            isOpen={
                isOpen
            }
            onClose={
                onClose
            }
            headerContent={
                <h2>
                    Edit
                    Commission
                    Rule
                </h2>
            }
            bodyContent={
                <Stack
                    spacing={4}
                >
                    <ReusableInput
                        label="Milestone"
                        value={
                            rule?.milestone_type ||
                            ""
                        }
                        isDisabled
                    />

                    <ReusableInput
                        label="Commission Amount (P)"
                        name="amount"
                        type="number"
                        value={
                            formData.amount
                        }
                        onChange={
                            handleChange
                        }
                    />

                    <ReusableInput
                        label="Effective From"
                        name="effective_from"
                        type="datetime-local"
                        value={
                            formData.effective_from
                        }
                        onChange={
                            handleChange
                        }
                    />

                    <FormControl
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Flex
                            alignItems="center"
                            gap={3}
                        >
                            <FormLabel mb="0">
                                Rule
                                Status
                            </FormLabel>

                            <Badge
                                colorScheme={
                                    formData.active
                                        ? "green"
                                        : "red"
                                }
                                borderRadius="full"
                                px={3}
                                py={1}
                            >
                                {formData.active
                                    ? "Active"
                                    : "Inactive"}
                            </Badge>
                        </Flex>

                        <Switch
                            isChecked={
                                formData.active
                            }
                            onChange={
                                handleToggle
                            }
                            sx={{
                                "& .chakra-switch__track[data-checked]":
                                    {
                                        backgroundColor:
                                            "#071D54",
                                    },
                            }}
                        />
                    </FormControl>
                </Stack>
            }
            footerContent={
                <Stack
                    direction="row"
                    spacing={4}
                    justifyContent="flex-end"
                >
                    <GradientButton
                        onClick={
                            onClose
                        }
                        width="100px"
                        height="40px"
                    >
                        Cancel
                    </GradientButton>

                    <GradientButton
                        onClick={
                            handleSubmit
                        }
                        width="100px"
                        height="40px"
                    >
                        Update
                    </GradientButton>
                </Stack>
            }
        />
    );
};

export default EditCommissionRuleDrawer;